import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

import { Skeleton } from '@audio-network/componentlibrary'
import styles from './TrackRow.module.css'

export const TrackRowSkeleton = (
	props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
): JSX.Element => {
	return (
		<div className={styles.trackRowrapper} {...props}>
			<div className={styles.trackRow}>
				<div className={styles.artwork}>
					<Skeleton height={56} width={56} variant="rounded" />
				</div>
				<div className={styles.playButton}>
					<div className={styles.details}>
						<span className={styles.title}>
							<Skeleton width={200} />
						</span>
						<div className={styles.composers}>
							<Skeleton width={160} />
						</div>
					</div>
				</div>
				<div className={styles.details}>
					<span className={styles.title}>
						<Skeleton width={200} />
					</span>
					<div className={styles.composers}>
						<Skeleton width={320} />
					</div>
				</div>
				<Skeleton height={16} width={32} variant="rounded" />
			</div>
		</div>
	)
}
